import { useState, useEffect, useRef } from "react";

interface IframeWithLoaderProps {
  src: string;
  title: string;
  loadingText?: string;
  allow?: string;
  className?: string;
  containerClassName?: string;
}

export default function IframeWithLoader({
  src,
  title,
  loadingText = "Loading...",
  allow = "payment",
  className = "w-full h-full border-0",
  containerClassName = "w-full h-screen rounded-2xl relative flex flex-col gap-10 justify-start items-center py-4 overflow-hidden",
}: IframeWithLoaderProps) {
  const [isLoading, setIsLoading] = useState(true);
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    setIsLoading(true);

    timeoutRef.current = setTimeout(() => {
      setIsLoading(false);
    }, 3000);

    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [src]);

  const handleIframeLoad = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    setIsLoading(false);
  };

  return (
    <div className={containerClassName}>
      {isLoading && (
        <div className="absolute inset-0 flex items-center justify-center bg-white/80 backdrop-blur-sm z-10">
          <div className="flex flex-col items-center gap-4">
            <div className="w-12 h-12 border-4 border-orange-200 border-t-orange-600 rounded-full animate-spin"></div>
            <p className="text-gray-600 text-sm font-medium">{loadingText}</p>
          </div>
        </div>
      )}

      <iframe
        ref={iframeRef}
        src={src}
        className={`${className} ${isLoading ? "opacity-0" : "opacity-100"}`}
        title={title}
        allow={allow}
        onLoad={handleIframeLoad}
      />
    </div>
  );
}
